<script setup lang="ts">
import MenuItem from '@/components/common/MenuItem.vue'
import TemplateSelector from '@/components/ui/ModuleSelector.vue'
import useEnvironmentStore from '@/stores/environmentStore'
import useModuleStore from '@/stores/moduleStore'
import { WhatNowContext } from '@/types'
import { storeToRefs } from 'pinia'
import { computed } from 'vue'

const env = useEnvironmentStore()
env.setContextId(WhatNowContext.Home)
env.title = 'page-titles.home'

const moduleStore = useModuleStore()
const { currentModule } = storeToRefs(moduleStore)

const totals = computed(() => {
  if (currentModule.value) {
    let descriptors = currentModule.value.descriptors
    let totalStatements = descriptors
      .map((d) => d.statementCount)
      .reduce((a, b) => {
        return a + b
      }, 0)
    let evaluatedStatements = descriptors
      .map((d) => d.evaluatedStatementCount)
      .reduce((a, b) => {
        return a + (b as unknown as number)
      }, 0)
    return Math.round((evaluatedStatements / totalStatements) * 100)
  } else {
    return 0
  }
})
</script>

<template>
  <TemplateSelector></TemplateSelector>
  <div class="pulse"></div>
  <div class="menu-wrapper">
    <MenuItem handler="analyse" block>
       {{ $t('menu.evaluations') }} ({{ totals }}%)
    </MenuItem>
    <MenuItem handler="summary" block>
      {{ $t('menu.summary') }}
    </MenuItem>
    <MenuItem handler="correlation" block>
      {{ $t('menu.correlation') }}
    </MenuItem>
    <MenuItem handler="worklog" block>
      {{ $t('menu.call-to-action') }}
    </MenuItem>
  </div>
</template>

<style scoped>
.pulse {
  width: 100%;
  background-image: linear-gradient(to right, red, yellow, green);
  border: none;
  border-radius: 8px 8px 0 0;
  padding: 5px 0;
  margin-bottom: 4px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
}
</style>
